import { ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { AppSettings } from './app-settings'

@Injectable()
export class ToastService {

    constructor(private toastCtrl: ToastController) {}

    private getToastConfig(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
        return {
            message: message,
            duration: 3000,
            position: 'bottom',
            cssClass: `ToastClass toast-${type}`,
            dismissOnPageChange: true,
            showCloseButton: false,
            closeButtonText: '✕'
        };
    }

    presentToast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
        const toast = this.toastCtrl.create(this.getToastConfig(message, type));
        toast.present();
    }

    // Convenience methods for different toast types
    success(message: string) {
        this.presentToast(message, 'success');
    }

    error(message: string) {
        this.presentToast(message, 'error');
    }

    warning(message: string) {
        this.presentToast(message, 'warning');
    }

    info(message: string) {
        this.presentToast(message, 'info');
    }

    // For longer duration messages
    presentLongToast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
        const config = this.getToastConfig(message, type);
        config.duration = 5000;
        config.showCloseButton = true;
        const toast = this.toastCtrl.create(config);
        toast.present();
    }
}


// WEBPACK FOOTER //
// ./src/services/toast-service.ts